var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'task-progress': true,
    done: _vm.isDone,
  }},[(_vm.isDone)?_c('SvgIcon',{staticClass:"icon-done",attrs:{"iconName":_vm.svgIconName,"aria-hidden":"true"}}):_vm._e(),_c('span',{attrs:{"role":"text"},domProps:{"innerHTML":_vm._s(_vm.progress)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }